import React from 'react';

import CategoryButton from '../../../../components/grid-header/categorize-button';

import { useProductContext } from '../product-context';

export default () => {
  const { selectedProductIds } = useProductContext();

  return <CategoryButton selectedIds={selectedProductIds} />;
};
